import type { EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import { EnvironmentChip, EphemeralEnvironmentChip, MissingChip, ParentEnvironmentChip } from "~/components/Chips/index";
interface EnvironmentOrMissingChipProps {
    environmentId: string;
    environments: EnvironmentV2Resource[];
    noMargin?: boolean;
}
export default ({ environmentId, environments, noMargin = false }: EnvironmentOrMissingChipProps) => {
    const environment = environments.find((e) => e.Id === environmentId);
    if (!environment) {
        return <MissingChip lookupId={environmentId} noMargin={noMargin}/>;
    }
    switch (environment.Type) {
        case "Ephemeral":
            return <EphemeralEnvironmentChip environmentName={environment.Name} noMargin={noMargin}/>;
        case "Parent":
            return <ParentEnvironmentChip environmentName={environment.Name} noMargin={noMargin}/>;
        case "Static":
        default:
            return <EnvironmentChip environmentName={environment.Name} noMargin={noMargin}/>;
    }
};
